export const XING_CLIENT_ID = "05d169496c7b880df45b";
